import React from 'react';
import Navigation from '../components/Navigation';
import ContactSection from '../sections/ContactSection';
import Footer from '../components/Footer';

export default function Contact() {
  return (
    <main id="main">
      <Navigation />
      <ContactSection />
      <Footer />
    </main>
  );
}
